'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Copy-module_container__i26nM{height:auto;vertical-align:middle;width:1rem;fill:#000}";
var styles = {"container":"Copy-module_container__i26nM"};
styleInject["default"](css_248z, 'db680b0b-3359-4df2-bb58-6e6a00f13c89');

exports["default"] = styles;
